import { Component, Input } from '@angular/core';

/**
 * Trazos de los íconos Tabler (MIT) que dibuja `PanicButton` en la app según la función del botón
 * (`iconoFuncion`: Sirena → Volume, Reflector → Bulb, Link → ExternalLink, 911 → Phone, resto →
 * AlertTriangle). Viewbox 24×24, trazo de 2.
 */
const TRAZOS: Record<string, string[]> = {
  Sirena: [
    'M15 8a5 5 0 0 1 0 8',
    'M17.7 5a9 9 0 0 1 0 14',
    'M6 15h-2a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h2l3.5 -4.5a.8 .8 0 0 1 1.5 .5v14a.8 .8 0 0 1 -1.5 .5l-3.5 -4.5',
  ],
  Reflector: [
    'M3 12h1m8 -9v1m8 8h1m-15.4 -6.4l.7 .7m12.1 -.7l-.7 .7',
    'M9 16a5 5 0 1 1 6 0a3.5 3.5 0 0 0 -1 3a2 2 0 0 1 -4 0a3.5 3.5 0 0 0 -1 -3',
    'M9.7 17l4.6 0',
  ],
  Link: [
    'M11 7h-5a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-5',
    'M10 14l10 -10',
    'M15 4l5 0l0 5',
  ],
  '911': [
    'M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2',
  ],
  alerta: [
    'M12 9v2m0 4v.01',
    'M5 19h14a2 2 0 0 0 1.84 -2.75l-7.1 -12.25a2 2 0 0 0 -3.5 0l-7.1 12.25a2 2 0 0 0 1.75 2.75',
  ],
};

/** Ícono del botón según su función, igual al de la app. Hereda el color del texto. */
@Component({
  selector: 'app-icono-funcion',
  template: `<svg
    [attr.width]="tamano"
    [attr.height]="tamano"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    @for (d of trazos; track $index) {
      <path [attr.d]="d" />
    }
  </svg>`,
  styles: [':host { display: inline-flex; flex: none; }'],
  standalone: false,
})
export class IconoFuncionComponent {
  @Input() funcion?: string;
  /** Lado en px. En la app es `alto del botón / 2.5`. */
  @Input() tamano = 20;

  get trazos(): string[] {
    return TRAZOS[this.funcion ?? ''] ?? TRAZOS['alerta'];
  }
}
